import { render } from "./milestone-tooltip-buttons.vue?vue&type=template&id=3f9f783f&scoped=true&ts=true"
import script from "./milestone-tooltip-buttons.vue?vue&type=script&lang=ts"
export * from "./milestone-tooltip-buttons.vue?vue&type=script&lang=ts"

import "./milestone-tooltip-buttons.vue?vue&type=style&index=0&id=3f9f783f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f9f783f"]])

export default __exports__